<script>
    import { createEventDispatcher } from 'svelte';
    import { onMount } from "svelte";
    import { fade } from 'svelte/transition';
    import moment from 'moment';
    import { sleep } from '../../scripts';

    export let value=''
    export let value2=''
    export let datos=[];
    export let label=''
    export let left=10;
    export let roundedStart=false;
    export let roundedEnd=false;
    export let tipo='text';
    export let disabled=false;
    export let error=false;
    export let autofocus=false;
    export let len=false;
    export let height=5;

    const dispatch = createEventDispatcher();

    let valueT='' // vars permutaciones
    let valueT2='' // vars permutaciones

    let move=(value=='')?15:4;
    let focus=false;
    let focuseded=false;
    let zindex=-1;
    let bold='bold';
    let moveX=0;
    let actualizar=true;
    let campo=false;
    let campo2=false;
    let eventRange=false;
    let timerKey=false;

    onMount(async () => {
        actualizar=true;
        if(autofocus)
        {
            campo.focus();
            campo.select();
        }
	});

    $: if(value) {
        if(actualizar===true)
        {
            focused();
            blured();
            actualizar=false;
        }
    }

/*    $: if(tipo=='date' && value=='') {
        value='00-00-0000';
    }
    $: if(tipo=='date' && value2=='') {
        value2='00-00-0000';
    }    */
    
    export function focusIn()
    {
        setTimeout(function() { 
            campo.focus();
            campo.select();
        },100)
    }

    export function onlyFocusIn()
    {
        setTimeout(function() { 
            campo.focus();
        },100)
    }    

    export function onlyFocusInNum(seg)
    {
        setTimeout(function() { 
            campo.focus();
        },seg)
    }  

    let focused=function() { 
        focus=true;
        focuseded=true;
        if(focus === true || value!='' || value==0 )
        {
            //move=-3;
            move=4;
            moveX=-18;
            zindex=10;
            bold='bold';
        }
    }
    let blured=function() { 

        focuseded=false;
        if((value=='' && value!==0) || value==null) focus=false; 
        if(focus === false) { move=15; zindex=-1; bold='bold'; moveX=0;}
    }

    let change=function() {
        dispatch('change', {});
    }

    let changeRange=function(e) {
            if(value=='') { 
                value2=''
            } else if(value!='00-00-0000' && value!='') {
                if(value2=='00-00-0000' || value2=='') {
                    value2=value;
                } else if( moment(value2) < moment(value)) {
                    value2=value;
                }
            }
            dispatch('change', {});
            return;
    }
    
    let changeRange2=function(e) {
        if(value2=='') { 
            value='';
        } else if((value=='00-00-0000' || value=='') && value2!='00-00-0000' && value2!='') {
            value=value2;
        }
        dispatch('change', {});
        return;
    }

    let FechaPredefinida=function(action) {
        if(action=='hoy')
        {
            value=moment().format('YYYY-MM-DD');
            value2=moment().format('YYYY-MM-DD');
        } else if(action=='ayer') {
            value=moment().subtract(1, "days").format('YYYY-MM-DD');
            value2=moment().subtract(1, "days").format('YYYY-MM-DD');
        } else if(action=='semana_actual') {
            value=moment().startOf('week').add(1, "days").format('YYYY-MM-DD');
            value2=moment().endOf('week').add(1, "days").format('YYYY-MM-DD');
        } else if(action=='semana_anterior') {
            value=moment().startOf('week').add(1, "days").subtract(1,'week').format('YYYY-MM-DD');
            value2=moment().endOf('week').add(1, "days").subtract(1,'week').format('YYYY-MM-DD');
            console.log( moment().startOf('week').add(1, "days").subtract(1,'week').format('YYYY-MM-DD') )
            console.log( moment().endOf('week').add(1, "days").subtract(1,'week').format('YYYY-MM-DD') )
        } else if(action=='mes_actual') {
            value=moment().startOf('month').format('YYYY-MM-DD');
            value2=moment().endOf('month').format('YYYY-MM-DD');
            console.log( moment().startOf('month').format('YYYY-MM-DD') )
            console.log( moment().endOf('month').format('YYYY-MM-DD') )
        } else if(action=='mes_anterior') {
            value=moment().subtract(1,'month').startOf('month').format('YYYY-MM-DD');
            value2=moment().subtract(1,'month').endOf('month').format('YYYY-MM-DD');
        } else if(action=='limpiar') {
            value='';
            value2='';
        }
        
        dispatch('change', {});
        return;      
    }

    let onEnter=function(e) {
        if(timerKey!==false) clearTimeout(timerKey)

        timerKey=setTimeout(function() { 
            if(e.keyCode==13) 
            {
                dispatch('enter', {});
            } else {
                dispatch('change', {});
            }
            
        },500)        
        
        return;
    }

</script>

{#if error!==false}
<p class='error text-danger' transition:fade="{{ duration: 500 }}"><i class="bi bi-exclamation-circle me-1"></i>{error}</p>
{/if}
<!-- svelte-ignore a11y-label-has-associated-control -->
<!-- svelte-ignore a11y-missing-attribute -->
<label
style='transform: translateY({move}px) !important; margin-left:{left}px;z-index:{zindex};font-weight: {bold};'
class:text-light3={focus === true || value!=''}
class:text-light2={focus === false}
class:text-primary={focuseded===true}
>{label.toUpperCase()}</label>

{#if tipo=='text'}
    <input {disabled} type='text' class="form-control {$$props.class}" autocomplete="new-password"
        class:border-danger={error!==false}
        class:rounded-start={roundedStart===true}
        class:rounded-end={roundedEnd===true}
        bind:value={value}
        on:focus={focused}
        on:blur={blured}
        bind:this={campo}
        maxlength={len}
        on:keydown={onEnter}
    >
{:else if tipo=='textarea'}
    <textarea {disabled} class="form-control {$$props.class}" autocomplete="new-password"
    class:border-danger={error!==false}
    class:rounded-start={roundedStart===true}
    class:rounded-end={roundedEnd===true}
    bind:value={value}
    on:focus={focused}
    on:blur={blured}
    bind:this={campo}
    maxlength={len}
    rows={height}
    ></textarea>   
{:else if tipo=='number'}
    <input {disabled} type='number' min="1" class="form-control {$$props.class}" autocomplete="new-password"
        class:border-danger={error!==false}
        class:rounded-start={roundedStart===true}
        class:rounded-end={roundedEnd===true}
        bind:value={value}
        on:focus={focused}
        on:blur={blured}
        bind:this={campo}
        maxlength={len}
        on:keypress={onEnter}
    >
{:else if tipo=='password'}
        <input {disabled} type='password' class="form-control {$$props.class}" autocomplete="new-password"
        class:border-danger={error!==false}
        class:rounded-start={roundedStart===true}
        class:rounded-end={roundedEnd===true}
        bind:value={value}
        on:focus={focused}
        on:blur={blured}
        bind:this={campo}
        maxlength={len}
        >
{:else if tipo=='date'}
    <input {disabled} type='date' class="form-control {$$props.class}" autocomplete="new-password"
        class:border-danger={error!==false}
        class:rounded-start={roundedStart===true}
        class:rounded-end={roundedEnd===true}
        bind:value={value}
        on:focus={focused}
        on:blur={blured}
        bind:this={campo}
        maxlength={len}
        on:change={change}
        >
{:else if tipo=='range'}
        <div class="input-group ">
            <input type='date' class="form-control" bind:value={value} bind:this={campo} on:change={changeRange} >
            <span class="input-group-text"><i class="bi bi-calendar3"></i></span>
            <input type='date' min={value} class="form-control" bind:value={value2} bind:this={campo2}  on:change={changeRange2}>

            <button class="btn btn-outline-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false"></button>
            <ul class="dropdown-menu dropdown-menu-end">
              
              <li><a class="dropdown-item" on:click={()=>FechaPredefinida('hoy')}>Hoy</a></li>
              <li><a class="dropdown-item" on:click={()=>FechaPredefinida('ayer')}>Ayer</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" on:click={()=>FechaPredefinida('semana_actual')}>Semana Actual</a></li>
              <li><a class="dropdown-item" on:click={()=>FechaPredefinida('semana_anterior')}>Semana Anterior</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" on:click={()=>FechaPredefinida('mes_actual')}>Mes Actual</a></li>
              <li><a class="dropdown-item" on:click={()=>FechaPredefinida('mes_anterior')}>Mes Anterior</a></li>
              <li><hr class="dropdown-divider"></li>
              <li><a class="dropdown-item" on:click={()=>FechaPredefinida('limpiar')}>Limpiar</a></li>
            </ul>

        </div>
{:else if tipo=='email'}
    <input {disabled} type='email' class="form-control {$$props.class}" autocomplete="new-password"
        class:border-danger={error!==false}
        class:rounded-start={roundedStart===true}
        class:rounded-end={roundedEnd===true}
        bind:value={value}
        on:focus={focused}
        on:blur={blured}
        bind:this={campo}
        maxlength={len}
        >
{:else if tipo=='select'}
        <!-- <input {disabled} type='email' class="form-control {$$props.class}" autocomplete="new-password"
            class:border-danger={error!==false}
            class:rounded-start={roundedStart===true}
            class:rounded-end={roundedEnd===true}
            bind:value={value}
            on:focus={focused}
            on:blur={blured}
            bind:this={campo}
            maxlength={len}
            >         -->
        <select {disabled} class="form-select {$$props.class}"
            class:border-danger={error!==false}
            class:rounded-start={roundedStart===true}
            class:rounded-end={roundedEnd===true}
            bind:value={value}
            autocomplete="new-password"
            bind:this={campo}
            on:change={change}
        >

            {#each datos as item,index}
                {#if typeof item === 'object'}
                    <option class='text-black' value="{String(Object.keys(item))}">{item[Object.keys(item)]}</option>
                {:else}
                    <option class='text-black' value="{item}">{item}</option>
                {/if}
            {/each}
         
            
        </select>            
{/if}

<style>

label {
    position:absolute;
    /*transition: transform .2s ease-in-out;*/
    transition: transform .2s ease-in-out;
    font-size:0.7em;
    line-height:0.7em;
    padding-left:4px;
    padding-right:4px;
    background-color:#fff;
    text-size-adjust: 80%;
    z-index:999;
}

input,select,textarea {
    background:transparent !important;
    box-shadow: none !important;
}
textarea {
    resize: vertical;
}
.text-light2 {
    color:#bbb;
}
.text-light3 {
    color:#aaa;
    font-size:0.5em;
    line-height:0.5em;
    /*transform: scale(0.7) !important;*/
}
p.error {
    position:absolute;
    margin-top:-8px;
    margin-left:10px !important;
    background:#fff;
    font-size: 0.6em;
    line-height:1em;
    padding-left:4px;
    padding-right:4px;
    z-index:9000
}
input::-ms-reveal,
      input::-ms-clear {
        display: none;
      }
.dropdown-menu LI A {
    cursor:pointer;
}
</style>